import * as React from "react";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Badge } from "components/ui/badge";
import { X } from "lucide-react";

interface AddMultipleRegionalContentProps {
  onConfirm: (items: string[]) => void;
  onCancel: () => void;
}

export function AddMultipleRegionalContent({
  onConfirm,
  onCancel,
}: AddMultipleRegionalContentProps) {
  const [items, setItems] = React.useState<string[]>([]);
  const [inputValue, setInputValue] = React.useState("");

  const addRegionalBadge = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      setItems([...items, inputValue.trim()]);
      setInputValue("");
    }
  };

  const removeRegionalBadge = (index: number) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const handleConfirm = () => {
    onConfirm(items);
  };

  return (
    <div className="flex flex-col gap-4">
      <Input
        type="text"
        placeholder="Digite uma regional"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyPress={addRegionalBadge}
        autoFocus
      />
      
      <div className="flex flex-wrap gap-2 min-h-[40px]">
        {items.map((item, index) => (
          <Badge
            key={index}
            variant="secondary"
            className="flex items-center gap-1"
          >
            {item}
            <X
              className="h-3 w-3 cursor-pointer"
              onClick={() => removeRegionalBadge(index)}
            />
          </Badge>
        ))}
      </div>

      {/* Footer com botões */}
      <div className="flex justify-end gap-3 pt-4 border-t">
        <Button variant="outline" onClick={onCancel}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          className={`rounded-md ${
            items.length === 0 ? "opacity-50 cursor-not-allowed" : ""
          }`}
          disabled={items.length === 0}
        >
          Adicionar Regionais
        </Button>
      </div>
    </div>
  );
}